<template>
  <div>
    <b-card class="bucket-card">
      <div class="d-flex justify-content-between align-items-center py-1 px-1">
        <div class="d-flex flex-column flex-grow-1">
          <div class="pl-1 d-flex align-items-center">
            <div class="bucket-name">
              {{ name.toUpperCase() }}
            </div>
            <div class="count">
              {{ count }}
            </div>
          </div>
        </div>
        <div>
          <b-button
            class="plus-button"
            size="sm"
            @click="viewBucket(id)"
          >
            <feather-icon
              icon="EyeIcon"
              size="16"
            />
          </b-button>
        </div>
      </div>
      <div
        v-if="isdestination"
        class="bucket-bottom px-1 pb-1"
      >
        <div class="pt-1 pl-1">
          <b-button
            class="add-new-bag"
            size="sm"
            @click="addNewBag"
          >
            Add New Bag&nbsp;<feather-icon
              icon="PlusIcon"
              size="14"
            />
          </b-button>
        </div>
        <div
          class="bag-row pt-1 d-flex justify-content-between"
        >
          <div class="pl-1 bag-info">
            <strong>Bag ID :</strong> {{ bagName }}
          </div>
          <div class="bag-order-count">
            <strong>Order Count :</strong> {{ bagCount }}
          </div>
        </div>
      </div>
    </b-card>
    <view-bucket-modal ref="viewBucketModal" />
  </div>
</template>

<script>
import {
  BCard, BButton,
} from 'bootstrap-vue'
import ViewBucketModal from '@/components/Sorting/ViewBucketModal.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const sortingRepository = RepositoryFactory.get('sorting')

export default {
  components: {
    BCard,
    BButton,
    ViewBucketModal,
  },
  props: {
    id: { type: Number, required: true },
    name: { type: String, required: true },
    count: { type: Number, required: true },
    bagName: { type: String, default: '' },
    bagCount: { type: Number, default: 0 },
    isdestination: { type: Boolean, default: false },
    isReport: { type: Boolean, default: false },
    sortingString: { type: String, default: '' },
  },
  data() {
    return {
      bagSequence: 1,
    }
  },
  // computed: {
  //   // Always render “BAG-<sequence>”
  //   bagId() {
  //     return `BAG-${this.bagSequence}`
  //   },
  // },
  methods: {
    viewBucket(id) {
      this.$refs.viewBucketModal.openModal(id, this.name, this.isdestination, this.isReport, this.sortingString)
    },
    async addNewBag() {
      // capture what the user just “closed”
      // const previousBagId = this.bagId
      // const previousOrderCount = this.bagOrderCount

      try {
        const response = await sortingRepository.createBag({
          bucket_node_id: this.id,
          sorting_id_string: this.sortingString,
        })
        if (response && response.data) {
          // Show success message
          this.bagName = response.data.data.display_name // Update bag name with the new bag ID
          this.bagCount = response.data.data.count // Update bag count with the new bag count
          // Reset bag sequence for next bag
          // this.bagSequence += 1
          // Optionally, you can show a success notification/toast here
        }
      } catch (err) {
        // console.error('Failed to add new bag:', err)
        // optionally show a notification/toast here
      }
    },
  },
}
</script>
<style>
.bucket-card {
  position: relative;      /* establish containing block for ::before */
  overflow: hidden;        /* clip pseudo‐element at border‐radius */
  border: 1px solid #bbbbbb;
  border-radius: 10px;
}
.bucket-card .card-body {
  padding: 0 !important; /* remove default padding */
}
.bucket-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 5%;
  height: 100%;
  background-color: rgba(115, 103, 240); /* choose your color */
}
.plus-button {
    color: rgb(115, 103, 240) !important;
    background-color: rgba(115, 103, 240, 0.2) !important;
    border-color: rgb(115, 103, 240) !important;
}
.plus-button:enabled {
    color: rgb(115, 103, 240) !important;
    background-color: rgba(115, 103, 240, 0.2) !important;
    border-color: rgb(115, 103, 240) !important;
}
.bucket-name {
  font-weight: 700;
  flex: 1;
  font-size: medium;
}
.count {
  font-size: large;
  font-weight: 900;
  background-color: rgba(115, 103, 240, 0.2);
  color: rgb(0, 0, 0);
  border-radius: 10%;
  text-align: center;
  flex: 1;
  margin-inline: 10%;
}
.add-new-bag {
  border-radius: 15px;
  background-color: #5046B0 !important;
}
.add-new-bag:enabled {
  background-color: #5046B0 !important;
}
.bag-info {
  color: #4A10AD;
  font-weight: 600;
}
.bag-info strong {
  color: #000;
}
.bucket-bottom {
  background-color: #E3E1FC;
}
.bag-order-count {
  background-color: #fff;
  padding: 5px;
  border-radius: 5px;
}
</style>
